<script>
    import R, {LOADER} from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import Checkbox from "./Checkbox.svelte";
    import AppIcon from "../icons/AppIcon.svelte";

    export let selected = [];

    let list = null;
    let code = '';
    let totalChecked = 0;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onCodeChange = (event) => {
        if (code) {
            load();
        }
    }

    const onKeyUp = (event) => {
        if (event.key === 'Enter' && code) {
            load();
        }
    }

    const toggleItem = (item) => {
        item.is_checked = item.is_checked ? 0 : 1;
        list = list;
    }

    const onSelectMulti = () => {
        let selected = list.filter(x => x.is_checked == 1);
        closeDropdown();
        code = '';
        dispatch("select", selected);
    }

    const onSelectAll = () => {
        list.map(item => {
            item.is_checked = 1;
        });
        list = list;
    }

    const onSelectNone = () => {
        list.map(item => {
            item.is_checked = 0;
        });
        list = list;
    }

    const closeDropdown = () => {
        list = null;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const load = () => {
        const onSuccess = result => {
            list = result;
            if (list.length) {
                document.addEventListener('keydown', handleEscapeKey);
                list.map(item => {
                    item.is_checked = selected.indexOf(item.id) > -1 ? 1 : 0;
                });
            }
        }

        const onFailure = err => {
        };

        let data = {
            term: code
        }

        R.handle(R.analyses.index, data, onSuccess, onFailure, LOADER.POPUP);
    }

    $: {
        if (list) {
            totalChecked = list.filter(x => x.is_checked == 1).length;
        } else {
            totalChecked = 0;
        }
    }
</script>

<div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="input-group">
        <input type="text" class="form-control" bind:value="{ code }" on:change={ onCodeChange } on:keyup={ onKeyUp }
               placeholder="κωδικός, παράμετρος ή υλικό">
        {#if list != null}
            <button class="btn btn-default" type="button" title="τσεκάρισμα όλων" on:click={ onSelectAll }>
                <AppIcon icon="plus-square" strokeWidth="2"/>
            </button>
            <button class="btn btn-default" type="button" title="καθαρισμός όλων" on:click={ onSelectNone }>
                <AppIcon icon="minus-square" strokeWidth="2"/>
            </button>
        {/if}
        {#if totalChecked > 0}
            <button class="btn btn-default" type="button" title="επιλογή" on:click={ onSelectMulti }>
                <AppIcon icon="check" strokeWidth="3"/>
            </button>
        {/if}
    </div>
    {#if list != null}
        <div class="dropdown analyses-dropdown">
            {#each list as item}
                <li class="dropdown-item d-flex align-items-center" on:click={ () => toggleItem(item) }>
                    <div>
                        <Checkbox bind:checked={item.is_checked}/>
                    </div>
                    <div class="code text-gray">{ item.code }</div>
                    <div class="parameter">{ item.name_el }</div>
                    <div class="material text-gray">{ item.material }</div>
                </li>
            {/each}
        </div>
    {/if}
</div>

<style>
    .analyses-dropdown .dropdown-item {
        cursor: pointer;
    }

    .analyses-dropdown .dropdown-item .code {
        width: 40px;
    }

    .analyses-dropdown .dropdown-item .parameter {
        width: calc(100% - 70px - 200px);
    }

    .analyses-dropdown .dropdown-item .material {
        width: 200px;
        text-align: right;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>